import { EstadoCPP, formatearBs, formatearNumero } from '@/lib/cpp';

interface CardItem {
  label: string;
  value: string;
  icon: string;
  accent: 'primary' | 'verde' | 'rojo';
  hint?: string;
}

const accentClasses: Record<string, string> = {
  primary: 'bg-[#2563EB]/10 text-[#2563EB]',
  verde: 'bg-[#16A34A]/10 text-[#16A34A]',
  rojo: 'bg-[#DC2626]/10 text-[#DC2626]',
};

const valueClasses: Record<string, string> = {
  primary: 'text-[#111827]',
  verde: 'text-[#16A34A]',
  rojo: 'text-[#DC2626]',
};

export default function ResumenCards({ estado }: { estado: EstadoCPP }) {
  const cards: CardItem[] = [
    {
      label: 'Stock inicial',
      value: `${formatearNumero(estado.stockInicial)} u.`,
      icon: 'ri-archive-2-line',
      accent: 'primary',
      hint: 'Al inicio del período',
    },
    {
      label: 'Entradas',
      value: `+${formatearNumero(estado.entradas)} u.`,
      icon: 'ri-arrow-down-circle-line',
      accent: 'verde',
      hint: 'Unidades incorporadas',
    },
    {
      label: 'Salidas',
      value: `-${formatearNumero(estado.salidas)} u.`,
      icon: 'ri-arrow-up-circle-line',
      accent: 'rojo',
      hint: 'Unidades retiradas',
    },
    {
      label: 'Saldo actual',
      value: `${formatearNumero(estado.saldoActual)} u.`,
      icon: 'ri-archive-line',
      accent: 'primary',
      hint: 'Al cierre del período',
    },
    {
      label: 'CPP vigente',
      value: formatearBs(estado.cppVigente),
      icon: 'ri-price-tag-3-line',
      accent: 'primary',
      hint: 'Costo promedio unitario',
    },
    {
      label: 'Valor del inventario',
      value: formatearBs(estado.valorInventario),
      icon: 'ri-money-dollar-circle-line',
      accent: 'primary',
      hint: 'Saldo × CPP',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 md:gap-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-white rounded-xl p-4 border border-gray-100 flex flex-col">
          <div className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${accentClasses[card.accent]}`}>
            <i className={`${card.icon} w-5 h-5 flex items-center justify-center`}></i>
          </div>
          <p className="text-xs text-gray-500 mb-1">{card.label}</p>
          <p className={`text-2xl font-bold leading-tight break-words ${valueClasses[card.accent]}`}>{card.value}</p>
          {card.hint && <p className="text-[11px] text-gray-400 mt-1">{card.hint}</p>}
        </div>
      ))}
    </div>
  );
}